import { EXPOSITION_STATUS, EXPOSITION_STATUS_DATA } from '@/modules/EventExhibition/constants';
import BaseModel from './base';
import User, { fetchUser } from './user';
import UserUtil from '@/utils/user.js';
import { VIDEO_HOSTINGS_TYPES } from '@/modules/UserEventLanding/constants';

import Hall from './exhibition-hall';

export default class Exposition extends BaseModel {
  #user;

  constructor(item, url) {
    super(item, url);
    // expand = owner,exhiibition_hall,tags,images,documents,links
    this.description = item.description;
    this.is_active = item.is_active || false;
    this.is_moderate = item.is_moderate || false;
    this.exhibition_hall_id = item.exhibition_hall_id;
    this.tags = item.tags || [];
    this.images = item.images || [];
    this.documents = item.documents || [];
    this.links = item.links || [];
    this.owner_id = item.owner_id;
    this.owner = item.owner ? new User(item.owner) : null;

    this.hall = item.hall ? new Hall(item.hall) : null;

    this.descripton = item.descripton || '';

    this.promo_video = item.promo_video || null;
    this.#user = new UserUtil();
  }

  get isOwner() {
    return this.#user.data?.id === this.owner_id;
  }

  get avatar() {
    const [avatar] = this.images;
    return avatar || null;
  }

  get status() {
    if (!this.is_active) return EXPOSITION_STATUS.draft;
    if (!this.is_moderate) return EXPOSITION_STATUS.moderate;
    return EXPOSITION_STATUS.active;
  }

  get statusData() {
    const { status } = this;
    return EXPOSITION_STATUS_DATA[status];
  }

  get isActive() {
    return this.status === EXPOSITION_STATUS.active;
  }

  get showStatus() {
    return !this.isActive;
  }

  get videos() {
    const hostings = Object.keys(VIDEO_HOSTINGS_TYPES);
    // Проверка, что это или ют, или рт, или вк, или дзен
    return (this.links || []).filter(({ link }) => hostings.find((hosting) => link.includes(hosting)));
  }

  fetchOwnerProfile() {
    if (!this.owner_id) return null;
    return fetchUser(this.owner_id).then(({ response, error }) => {
      const [user] = response?.data?.data || [];
      if (user) {
        this.owner = new User(user);
      }
      return { response, error };
    });
  }

  async publish() {
    if (!this.url) this.url = 'exhibition-expositions';
    return this.update({
      data: {
        is_moderate: true,
        is_active: true,
      },
    });
  }
}
